import { Lookup } from "../models";

export const Lookups: Lookup[] = [
  {
    id: 1,
    name: "Enum",
    code: "enum",
    description: "Enum",
    isActive: true,
  }
]
